import Utils from 'src/utils';
import toastrError from 'src/helpers/toastr/toastrError';
import toastrSuccess from 'src/helpers/toastr/toastrSuccess';
import communicate from 'src/api/communicate';

export const LOAD_PROFESSIONS_REQUEST = 'LOAD_PROFESSIONS_REQUEST';
export const LOAD_PROFESSIONS_SUCCESS = 'LOAD_PROFESSIONS_SUCCESS';
export const LOAD_PROFESSIONS_FAIL = 'LOAD_PROFESSIONS_FAIL';

export const POST_PROFESSIONS_REQUEST = 'POST_PROFESSIONS_REQUEST';
export const POST_PROFESSIONS_SUCCESS = 'POST_PROFESSIONS_SUCCESS';
export const POST_PROFESSIONS_FAIL = 'POST_PROFESSIONS_FAIL';

export const PUT_PROFESSIONS_REQUEST = 'PUT_PROFESSIONS_REQUEST';
export const PUT_PROFESSIONS_SUCCESS = 'PUT_PROFESSIONS_SUCCESS';
export const PUT_PROFESSIONS_FAIL = 'PUT_PROFESSIONS_FAIL';

export const DELETE_PROFESSIONS_REQUEST = 'DELETE_PROFESSIONS_REQUEST';
export const DELETE_PROFESSIONS_SUCCESS = 'DELETE_PROFESSIONS_SUCCESS';
export const DELETE_PROFESSIONS_FAIL = 'DELETE_PROFESSIONS_FAIL';

export const LOAD_USER_PROFESSIONS_REQUEST = 'LOAD_USER_PROFESSIONS_REQUEST';
export const LOAD_USER_PROFESSIONS_SUCCESS = 'LOAD_USER_PROFESSIONS_SUCCESS';
export const LOAD_USER_PROFESSIONS_FAIL = 'LOAD_USER_PROFESSIONS_FAIL';

export const POST_USER_PROFESSIONS_REQUEST = 'POST_USER_PROFESSIONS_REQUEST';
export const POST_USER_PROFESSIONS_SUCCESS = 'POST_USER_PROFESSIONS_SUCCESS';
export const POST_USER_PROFESSIONS_FAIL = 'POST_USER_PROFESSIONS_FAIL';

export const PUT_USER_PROFESSIONS_REQUEST = 'PUT_USER_PROFESSIONS_REQUEST';
export const PUT_USER_PROFESSIONS_SUCCESS = 'PUT_USER_PROFESSIONS_SUCCESS';
export const PUT_USER_PROFESSIONS_FAIL = 'PUT_USER_PROFESSIONS_FAIL';

export const DELETE_USER_PROFESSIONS_REQUEST = 'DELETE_USER_PROFESSIONS_REQUEST';
export const DELETE_USER_PROFESSIONS_SUCCESS = 'DELETE_USER_PROFESSIONS_SUCCESS';
export const DELETE_USER_PROFESSIONS_FAIL = 'DELETE_USER_PROFESSIONS_FAIL';

const loadProfessionsRequest = () => ({ type: LOAD_PROFESSIONS_REQUEST });
const loadProfessionsSuccess = (professions) => ({ type: LOAD_PROFESSIONS_SUCCESS, professions });
const loadProfessionsFail = () => ({ type: LOAD_PROFESSIONS_FAIL });

const postProfessionRequest = () => ({ type: POST_PROFESSIONS_REQUEST });
const postProfessionSuccess = (profession) => ({ type: POST_PROFESSIONS_SUCCESS, profession });
const postProfessionFail = () => ({ type: POST_PROFESSIONS_FAIL });

const putProfessionRequest = () => ({ type: PUT_PROFESSIONS_REQUEST });
const putProfessionSuccess = (profession) => ({ type: PUT_PROFESSIONS_SUCCESS, profession });
const putProfessionFail = () => ({ type: PUT_PROFESSIONS_FAIL });

const deleteProfessionRequest = () => ({ type: DELETE_PROFESSIONS_REQUEST });
const deleteProfessionSuccess = (profession) => ({ type: DELETE_PROFESSIONS_SUCCESS, profession });
const deleteProfessionFail = () => ({ type: DELETE_PROFESSIONS_FAIL });

const loadUserProfessionsRequest = () => ({ type: LOAD_USER_PROFESSIONS_REQUEST });
const loadUserProfessionsSuccess = (data) => ({ type: LOAD_USER_PROFESSIONS_SUCCESS, data });
const loadUserProfessionsFail = (err) => ({ type: LOAD_USER_PROFESSIONS_FAIL, err });

const postUserProfessionsRequest = () => ({ type: POST_USER_PROFESSIONS_REQUEST });
const postUserProfessionsSuccess = (data) => ({ type: POST_USER_PROFESSIONS_SUCCESS, data });
const postUserProfessionsFail = (err) => ({ type: POST_USER_PROFESSIONS_FAIL, err });

const putUserProfessionsRequest = () => ({ type: PUT_USER_PROFESSIONS_REQUEST });
const putUserProfessionsSuccess = (data) => ({ type: PUT_USER_PROFESSIONS_SUCCESS, data });
const putUserProfessionsFail = (err) => ({ type: PUT_USER_PROFESSIONS_FAIL, err });

const deleteUserProfessionsRequest = () => ({ type: DELETE_USER_PROFESSIONS_REQUEST });
const deleteUserProfessionsSuccess = (data) => ({ type: DELETE_USER_PROFESSIONS_SUCCESS, data });
const deleteUserProfessionsFail = (err) => ({ type: DELETE_USER_PROFESSIONS_FAIL, err });

export const loadProfessions = () => (dispatch) => {
  dispatch(loadProfessionsRequest());
  return communicate({ url: 'Professions' })
    .then(({ data }) => dispatch(loadProfessionsSuccess(data.Data)))
    .catch((err) => {
      toastrError(err);
      dispatch(loadProfessionsFail());
    });
};

export const postProfession = (params) => (dispatch) => {
  dispatch(postProfessionRequest());
  return communicate({ url: 'Professions', method: 'post', data: params }).then((response) => {
    dispatch(postProfessionSuccess(response.data.Data));
    toastrSuccess(response);
    return response.data.Data;
  }).catch((e) => {
    dispatch(postProfessionFail(e));
    toastrError(e);
  });
};

export const putProfession = (department) => (dispatch) => {
  dispatch(putProfessionRequest(department));
  return communicate({ url: 'Professions', method: 'put', data: department })
    .then((response) => {
      dispatch(putProfessionSuccess(response.data.Data));
      toastrSuccess(response);
      return response.data.Data;
    }).catch((e) => {
      dispatch(putProfessionFail(e));
      toastrError(e);
    });
};

export const deleteProfession = (params) => (dispatch) => {
  dispatch(deleteProfessionRequest());
  return communicate({ url: 'Professions', method: 'delete', getParams: Utils.objects.getQueryStringFromObject(params) })
    .then((response) => {
      toastrSuccess(response);
      dispatch(deleteProfessionSuccess(params));
    }).catch((e) => {
      dispatch(deleteProfessionFail(e));
      toastrError(e);
    });
};

export const loadUserProfessions = ({ userIds }) => (dispatch) => {
  dispatch(loadUserProfessionsRequest());
  return communicate({
    url: 'UserProfessions',
    getParams: Utils.objects.getQueryStringFromObject({ userIds })
  })
    .then(({ data }) => {
      dispatch(loadUserProfessionsSuccess({ professions: data.Data, userId: userIds }));
    })
    .catch((err) => {
      dispatch(loadUserProfessionsFail(err));
    });
};

export const postUserProfessions = (params) => (dispatch) => {
  dispatch(postUserProfessionsRequest());
  return communicate({
    url: 'UserProfessions',
    method: 'post',
    data: params
  })
    .then(({ data }) => {
      toastrSuccess(data);
      dispatch(postUserProfessionsSuccess({ professions: data.Data, userId: params.UserId }));
    })
    .catch((err) => {
      dispatch(postUserProfessionsFail(err));
      toastrError(err);
    });
};

export const putUserProfessions = (params) => (dispatch) => {
  dispatch(putUserProfessionsRequest());
  return communicate({
    url: 'UserProfessions',
    method: 'put',
    data: params
  })
    .then(({ data }) => {
      toastrSuccess(data);
      dispatch(putUserProfessionsSuccess({ professions: data.Data, userId: params.UserId }));
    })
    .catch((err) => {
      dispatch(putUserProfessionsFail(err));
      toastrError(err);
    });
};

export const deleteUserProfessions = (params) => (dispatch) => {
  dispatch(deleteUserProfessionsRequest());
  return communicate({
    url: 'UserProfessions',
    method: 'delete',
    getParams: Utils.objects.getQueryStringFromObject({ id: params.id })
  })
    .then((response) => {
      toastrSuccess(response);
      dispatch(deleteUserProfessionsSuccess(params));
    })
    .catch((err) => {
      dispatch(deleteUserProfessionsFail(err));
      toastrError(err);
    });
};
